import React from 'react';
import { Link } from 'react-router';
import styled from 'styled-components';
import big9Logo from './../../images/icons/big9/Big9Logo.svg';
import { Big9Routes, Big9RoutesTerminals } from '../../constants/big9Config';
import { breakpoint } from '../../constants/breakpoints';
import { isTerminal } from '../../utils/UiHelper';
import BackButton from 'features/SpilKlub/components/BackButton';
import { browserHistory } from 'react-router';
import closeIcon from './../../images/icons/big9/topbar-close.svg';
import useScreens, {
    CREATE_GROUP_SLUG,
    GROUP_LIST_SLUG,
    POOL_DETAILS_SLUG,
    POOL_LIST_SLUG,
} from '../../features/SpilKlub/screens/useScreens';
import useTweaks from '../../features/SpilKlub/state/useTweaks';

const TopBarWrapper = styled.section`
    height: auto;
    width: 100%;
    margin: 0;
    padding: 25px 30px;
    background: #284768;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    /*overflow: hidden;*/
    position: relative;
    &.terminal {
        height: 50px;
        width: auto;
        background: transparent;
        position: fixed;
        padding: 0;
        left: 85px;
        top: 60px;
        z-index: 3;
    }
    @media screen and ${breakpoint.B} {
        padding-left: 30px;
        justify-content: space-around;
    }
    @media screen and ${breakpoint.N} {
        padding: 0;
        flex-direction: column;
        justify-content: center;
        background: transparent;
    }
`;

/*const JackpotWrapper = styled.div`
    height: 60px;
    width: 300px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #333;
    font-size: 23px;
    line-height: 23px;
    transform: rotate(-30deg);
    padding-right: 50px;
    font-weight: bold;
    background: #fdd200;
    position: absolute;
    left: -40px;
    top: 0;
    z-index: 1;
`;*/

const LogoWrapper = styled.div`
    height: auto;
    width: auto;
    box-sizing: border-box;
    margin-right: 50px;
    img {
        height: 45px;
        width: auto;
    }
    @media screen and ${breakpoint.B} {
        margin: 0;
    }
    @media screen and ${breakpoint.N} {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background: #1c3e60;
        padding: 18px 13px;
        img {
            height: 40px;
            width: auto;
        }
    }
`;

const RouterWrapper = styled.ul`
    height: auto;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    li {
        height: auto;
        margin: 0 30px 0 0;
        padding: 0;
        display: block;
        box-sizing: border-box;
        &:last-child {
            margin-right: 0;
        }
        a {
            display: block;
            box-sizing: border-box;
            font-weight: 700;
            font-family: 'Roboto Condensed', sans-serif;
            font-size: 20px;
            line-height: 20px;
            color: #c6ccdb;
            border-bottom: none;
            text-decoration: none;
            transition: all 0.2s ease-in-out;
            &:hover {
                color: #fff;
            }
            &.active {
                color: #fff;
            }
        }
    }
    @media screen and ${breakpoint.B} {
        li {
            margin-right: 20px;
        }
    }
    @media screen and ${breakpoint.N} {
        justify-content: space-around;
        padding: 0 20px 10px;
        background: #edf1f8;
        width: 100%;
        li {
            a {
                font-size: 14px;
                line-height: 14px;
                color: #1c3e60;
                padding: 10px 2px 0;
                border-top: 4px solid transparent;
                border-radius: 2px;
                &:hover {
                    color: #1c3e60;
                }
                &.active {
                    color: #1c3e60;
                    border-top: 4px solid #fed804;
                }
            }
        }
    }
    @media screen and ${breakpoint.S} {
        justify-content: space-between;
    }

    @media screen and (max-width: 320px) {
        padding: 0 10px 10px;
        li {
            margin-right: 10px;
        }
    }
`;

const CloseIcon = styled.img`
    position: absolute;
    right: 20px;
    @media screen and (min-width: 1024px) {
        top: 50%;
        transform: translateY(-50%);
    }
`;

const HIDE_LINKS_FOR_SCREENS = [CREATE_GROUP_SLUG];
const HIDE_BACK_BTN_FOR_SCREENS = [GROUP_LIST_SLUG];
const SHOW_CLOSE_BTN_FOR_SCREENS = [CREATE_GROUP_SLUG];

const goBackResolvers = {
    [POOL_LIST_SLUG]: (setScreen) => {
        setScreen(GROUP_LIST_SLUG);
    },
    // After group creation or adding a pool, 'go back' button should navigate to the group details
    [POOL_DETAILS_SLUG]: (setScreen, { uiGroupId, setUIGroupId }) => {
        if (uiGroupId) {
            setScreen(POOL_LIST_SLUG, uiGroupId, null, true);
            return setUIGroupId(0);
        }
    },
};

const Big9TopBar = ({ screen }) => {
    const { setScreen } = useScreens();
    const { uiGroupId, setUIGroupId } = useTweaks();

    const getRoutes = () => {
        let routes = isTerminal() ? Big9RoutesTerminals : Big9Routes;
        return routes.map((link, index) => {
            return (
                <li key={index}>
                    <Link activeClassName="active" to={link.to}>
                        {link.label}
                    </Link>
                </li>
            );
        });
    };

    const hideLinks = HIDE_LINKS_FOR_SCREENS.includes(screen);
    const hideBackBtn = HIDE_BACK_BTN_FOR_SCREENS.includes(screen) || !screen;
    const showCloseButton = SHOW_CLOSE_BTN_FOR_SCREENS.includes(screen);

    const screenHasSpecificHandler = Boolean(goBackResolvers[screen]);

    const goBackHandler = screenHasSpecificHandler
        ? () => goBackResolvers[screen](setScreen, { uiGroupId, setUIGroupId })
        : browserHistory.goBack;

    return (
        <TopBarWrapper className={isTerminal() ? 'terminal' : null}>
            {/*<JackpotWrapper>Jackpot</JackpotWrapper>*/}
            {!isTerminal() ? (
                <LogoWrapper>
                    {!hideBackBtn && (
                        <BackButton goBackHandler={goBackHandler} />
                    )}
                    <img src={big9Logo} alt="Logo" />
                    {showCloseButton && (
                        <CloseIcon
                            src={closeIcon}
                            alt="close"
                            style={{ height: '35px' }}
                            onClick={goBackHandler}
                            className="fade-in"
                        />
                    )}
                </LogoWrapper>
            ) : null}
            {!hideLinks && (
                <RouterWrapper className={isTerminal() ? 'terminal' : null}>
                    {getRoutes() || null}
                </RouterWrapper>
            )}
        </TopBarWrapper>
    );
};

export default Big9TopBar;
